/**
 * Audit Trail skeleton loader — shown while initial events are fetching.
 *
 * sl-wmbt.5.2: Skeleton loader extracted from audit-trail-panel.
 */
import * as styles from './audit-trail-panel.css';

export const EventSkeleton = () => (
  <div className={styles.skeletonList}>
    {[...Array(5)].map((_, i) => (
      <div key={i} className={styles.skeletonRow}>
        <div className={`${styles.skeletonCell} ${styles.skeletonCellTime}`} />
        <div className={`${styles.skeletonCell} ${styles.skeletonCellBadge}`} />
        <div
          className={`${styles.skeletonCell} ${styles.skeletonCellAction}`}
        />
        <div className={`${styles.skeletonCell} ${styles.skeletonCellUser}`} />
      </div>
    ))}
  </div>
);
